import { HttpStatusCode } from 'axios';

import { httpStatusOf } from 'src/common/ProblemDetail';
import { httpClient2 } from 'src/infrastructure/admi-client/http-client';
import { OfferDetail, OfferListItemDto, UploadOfferResultDto } from './offer-processing.dto';
import { PaginatedResponseDto } from 'src/infrastructure/admi-client/response.dto';

export const offerProcessingService = {
    uploadOfferFile: async (file: File): Promise<UploadOfferResultDto> => {
        console.debug('Upload offer file', file.name);
        const formData = new FormData();
        formData.append('file', file);

        const response = await httpClient2.post<UploadOfferResultDto>('/v1/offers/uploads', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    },

    listOffers: async (
        page: number,
        perPage: number,
        searchString: string,
    ): Promise<PaginatedResponseDto<OfferListItemDto>> => {
        const response = await httpClient2.get<PaginatedResponseDto<OfferListItemDto>>('/v1/offers', {
            params: { page, size: perPage, fileName: searchString },
        });
        return response.data;
    },

    retryOffer: async (id: string): Promise<void> => {
        await httpClient2.post(`/v1/offers/${id}/retry`, {});
    },

    deleteOffer: async (id: string): Promise<void> => {
        await httpClient2.delete(`/v1/offers/${id}`);
    },

    getOffer: async (fileId: string): Promise<OfferDetail> => {
        const response = await httpClient2.get<OfferDetail>(`/v1/offers/${fileId}`);
        return response.data;
    },
    /**
     * `null` means the offer record is not there — callers polling a freshly
     * uploaded file treat that as "not ready yet" and keep waiting. Uses
     * `httpStatusOf` because the response interceptor rejects with the bare
     * ProblemDetail body, not an AxiosError.
     */
    getOfferOrNull: async (fileId: string): Promise<OfferDetail | null> => {
        try {
            return await offerProcessingService.getOffer(fileId);
        } catch (err) {
            if (httpStatusOf(err) === HttpStatusCode.NotFound) {
                return null;
            }
            throw err;
        }
    },
};
